<template>
	<div
		class="pointer w-100"
		ref="customSelect"
		@click="toggleOptions"
		:class="
			(validation && validation.$error) || qualificationError
				? 'error-candash-custom-select'
				: disabled
				? 'defaultCursor candash-disable'
				: 'candash-custom-select'
		"
		tabindex="0"
		:disabled="disabled"
	>
		<div
			:class="
				(validation && validation.$error) || qualificationError
					? 'error-select-box'
					: disabled
					? 'defaultCursor'
					: 'select-box'
			"
			:aria-expanded="showOptions"
			tabindex="-1"
		>
			<div>
				{{ selectedOption ? selectedOptionDisplay : "Select" }}
			</div>
			<div class="">
				<img src="../assets/icons/candDashboard/greenDownArrow.svg" alt="" />
			</div>
		</div>
		<ul
			class="select-options"
			:style="
				type == 'interpersonalSkill'
					? 'top: -140px;box-shadow: 0px -3px 15px 0px #00000066;'
					: ''
			"
			v-if="showOptions"
		>
			<li
				v-for="(option, index) in options"
				:key="index"
				class="select-option"
				:class="{ selected: isSelected(option.value) }"
				@click.stop="selectOption(option.disabled == true ? this.selectedOption : option)"
				@keydown.enter="selectOption(option)"
				:tabindex="index === 0 ? 0 : -1"
			>
				{{ option.text }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data() {
		return {
			selectedOption: "",
			showOptions: false,
		};
	},
	props: {
		options: Array,
		selOption: String,
		validation: Object,
		type: String,
		qualificationError: Boolean,
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		selOption(newValue, oldValue) {
			if (newValue != oldValue) {
				const selectedIndex = this.options.findIndex(
				(option) => option.text === this.selOption
			);
			if(selectedIndex > -1){
				this.selectedOption = this.options[selectedIndex];
			}
			}
		},
	},
	computed: {
		selectedOptionDisplay() {
			const selectedIndex = this.options.findIndex(
				(option) => option.value === this.selectedOption.value
			);
			return selectedIndex > -1
				? this.options[selectedIndex].text
				: "Select";
		},
	},
	mounted() {
		// document.addEventListener("click", this.closeDropdownOnClickOutside);
		const selectedIndex = this.options.findIndex(
				(option) => option.text === this.selOption
			);
			if(selectedIndex > -1){
		this.selectedOption = this.options[selectedIndex];
			}
		// if (this.type != "edu") {
		//   this.$refs.customSelect.addEventListener(
		//     "focus",
		//     this.openDropdownOnFocus
		//   );
		// }
	},
	// beforeDestroy() {
	// 	document.removeEventListener("click", this.closeDropdownOnClickOutside);
	// 	this.$refs.customSelect.removeEventListener(
	// 		"focus",
	// 		this.openDropdownOnFocus
	// 	);
	// },
	methods: {
		toggleOptions() {
			this.showOptions = !this.showOptions;
			// if (this.showOptions) {
			// 	// If dropdown is being opened, focus on the select box after a small delay
			// 	setTimeout(() => {
			// 		this.$refs.customSelect.focus();
			// 	}, 10); // Adjust the delay time as needed
			// }
		},

		openDropdownOnFocus() {
			this.showOptions = true;
		},
		selectOption(option) {
			this.selectedOption = option;
			this.showOptions = false;
			this.$emit("selected-option", this.selectedOption);
		},
		isSelected(option) {
			return option === this.selectedOption;
		},
		handleKeyPress(event) {
			const options = this.options;
			const selectedIndex = options.findIndex(
				(option) => option.value === this.selectedOption
			);

			if (event.key === "ArrowDown" && selectedIndex < options.length - 1) {
				// Move selection down
				if (!this.showOptions) {
					this.showOptions = true;
				}
				this.selectedOption = options[selectedIndex + 1].disabled
					? this.selectedOption
					: options[selectedIndex + 1].value;
				this.$emit("selected-option", this.selectedOption);
				event.preventDefault(); // Prevent default behavior
			} else if (event.key === "ArrowUp" && selectedIndex > 0) {
				// Move selection up
				this.selectedOption = options[selectedIndex - 1].disabled
					? this.selectedOption
					: options[selectedIndex - 1].value;
				this.$emit("selected-option", this.selectedOption);
				event.preventDefault(); // Prevent default behavior
			} else if (event.key === "Enter") {
				this.toggleOptions();
			}
		},
		closeDropdownOnClickOutside(event) {			
			if (!this.$refs.customSelect.contains(event.target)) {
				this.showOptions = false;
			}
		},
		closeDropdownOnFocusOut(event) {
			// Check if the focus is outside the custom select component
			if (!this.$refs.customSelect.contains(event.relatedTarget)) {
				this.showOptions = true; // Close the dropdown
			}
		},
	},
};
</script>

<style>
/* Add your custom styles here */
.candash-custom-select {
	position: relative;
	display: inline-block;
}

.select-box {
	padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
	cursor: pointer;
	display:flex;
	align-items:center;
	justify-content:space-between;
	width: 100%;
}
.error-select-box {
	padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px; 
	cursor: pointer;
	padding: 5px;
}

.textarea-select-options {
	position: absolute;
	top: 60px;
	left: 15px;
	background-color: #fff;
	border-top: none;
	border-radius: 4px;
	padding: 0;
	list-style: none;
	width: 98%;
	overflow-y: auto;
	z-index: 3;
	border: 1px solid #2988e638;
	box-shadow: 0px 8px 15px 0px #00000066;
}
/* .textarea-select-options .select-option:first-child {
	color: #8c8c8c !important;
	font-size: 12px !important;
	font-weight: 400;
	font-family: "montserrat", sans-serif;
	background-color: transparent;
} */
.select-option {
	padding: 4px 10px;
	cursor: pointer;
	color: #333 !important;
	font-size: 13px !important;
	font-weight: 500 !important;
}

.select-option:hover {
	background-color: #e8eff4;
}

.select-option.selected {
	background-color: #c8d9e5;
}

.select-box:focus-visible {
	width: 100%;
	outline: none;
}
.candash-modalInput .candash-custom-select {
	outline: none;
}

.candash-disable {
	height: 32px !important;
	border-radius: 8px !important;
	border: 1px solid var(--gray-300, #d0d5dd) !important;
	background: #eeeeee !important;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;
	color: #332d2d !important;
	font-size: var(--size-12) !important;
	font-weight: 500 !important;
	display: flex;
	align-items: center;
	padding-left: 10px;
}
.candash-custom-select:focus-visible {
	outline: none;
}
</style>
